// extracted by mini-css-extract-plugin
export default {"MessagesPage":"MessagingPage_MessagesPage__rkrek","centerCell":"MessagingPage_centerCell__69Go8","centerIconCell":"MessagingPage_centerIconCell__c27RS"};